module.exports = __webpack_public_path__ + "img/smiley_sad2.2472110e.png";